import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import logger from "@/utils/logger";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA + auto-refresh on new deploys.
// When a new SW is installed (but waiting), tell it to activate and then
// reload the page so users always run the latest JS bundles after a deploy.
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {
        // Check for updates every 60s while the app is open.
        setInterval(() => reg.update().catch(() => {}), 60_000);

        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // New content is available — skip waiting so controllerchange fires
              // and we reload into the new bundle automatically.
              installing.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((err) => logger.warn('SW registration failed:', err));
  });
}
